import axios from 'axios';
import { BACKEND } from '../../constants/urls'
import { auth } from '../firebase';

/**
 * Obtener licencias de software
 * @param {*} filtro
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
export function getLicenciasSoftware(filter = {}, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/licencias-software`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      params: filter,
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Disponibilidad y reservas por producto, desde el servicio de licencias (fuente
 * oficial). Exige la sesión de la persona y el permiso verListadoLicenciasSoftware.
 */
export async function getDisponibilidadLicencias() {
  const token = await auth.currentUser.getIdToken();
  const res = await axios.get(`${BACKEND}/licencias-software/disponibilidad`, {
    headers: { authorization: `Bearer ${token}` },
  });
  return res.data;
}

async function cabeceras() {
  return { authorization: `Bearer ${await auth.currentUser.getIdToken()}` };
}

/** Si la persona puede mantener el stock de licencias (permiso gestionarStockLicencias). */
export async function getPermisosStockLicencias() {
  const res = await axios.get(`${BACKEND}/licencias-software/stock/permisos`, { headers: await cabeceras() });
  return res.data;
}

/** Id de la operación: un reintento con el mismo id no repite la escritura. */
export function nuevaOperacionId() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return `op-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** Crea una licencia (producto) con sus contratadas, en uso y precios. */
export async function crearProductoLicencia(datos) {
  const res = await axios.post(`${BACKEND}/licencias-software/productos`, datos, { headers: await cabeceras() });
  return res.data;
}

/** Edita una licencia; `datos.version` es la versión que se vio en la tabla. */
export async function editarProductoLicencia(productoId, datos) {
  const res = await axios.put(`${BACKEND}/licencias-software/productos/${encodeURIComponent(productoId)}`, datos, { headers: await cabeceras() });
  return res.data;
}

/**
 * Obtener licencia de software por id
 * @param {*} id
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
export async function getLicenciaSoftwarePorID(id, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/licencias-software/${id}`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Agregar licencia de software
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function postLicenciaSoftware(data, cancelToken = null) {
  let url = `${BACKEND}/licencias-software`;
  return axios.post(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Modificar licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function putLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/licencias-software/${id}`;
  return axios.put(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Eliminar licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function deleteLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/licencias-software/${id}`;
  return axios.delete(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}


/**
 * Obtener asignaciones licencias de software
 * @param {*} filtro
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
 export function getAsignacionesLicenciasSoftware(filter = {}, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/asignacion-licencias-software`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      params: filter,
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Obtener asignacion licencia de software por id
 * @param {*} id
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
export async function getAsignacionesLicenciaSoftwarePorID(id, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/asignacion-licencias-software/${id}`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Agregar asignacion licencia de software
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function postAsignacionLicenciaSoftware(data, cancelToken = null) {
  let url = `${BACKEND}/asignacion-licencias-software`;
  return axios.post(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Modificar asignacion licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function putAsignacionLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/asignacion-licencias-software/${id}`;
  return axios.put(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Eliminar asignacion licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function deleteAsignacionLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/asignacion-licencias-software/${id}`;
  return axios.delete(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}



/**
 * Obtener logs licencias de software
 * @param {*} filtro
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
 export function getLogsLicenciasSoftware(filter = {}, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/logs-licencias-software`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      params: filter,
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Obtener log licencia de software por id
 * @param {*} id
 * @param {Array} selects lista de campos a consultar
 * @param {Array} populates lista de campos a poblar
 * @param {*} cancelToken token para cancelacion
 */
export async function getLogLicenciaSoftwarePorID(id, selects = [], populates = [], cancelToken = null) {
  let url = `${BACKEND}/logs-licencias-software/${id}`;
  if (selects) selects.forEach(select => {
    url = url + "/" + select;
  });
  if (populates) populates.forEach(populate => {
    url = url + "/" + populate;
  });
  return axios.get(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Agregar log licencia de software
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function postLogLicenciaSoftware(data, cancelToken = null) {
  let url = `${BACKEND}/logs-licencias-software`;
  return axios.post(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Modificar log licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function putLogLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/logs-licencias-software/${id}`;
  return axios.put(url, data,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}

/**
 * Eliminar log licencia de software
 * @param {*} id
 * @param {Object} data
 * @param {*} cancelToken token para cancelacion
 */
export async function deleteLogLicenciaSoftware(id, data, cancelToken = null) {
  let url = `${BACKEND}/logs-licencias-software/${id}`;
  return axios.delete(url,
    {
      cancelToken: cancelToken
    }).then(res => res.data ? res.data : null);
}